import { getDetailsCount, getNumberOfResultsString } from '../utils/search';

function renderCollectionImage(collection) {
  if (collection.image === null || collection.image === undefined) {
    return '';
  }

  return `
    <div class="placeholder-background placeholder-background--animation" data-image-placeholder aria-hidden="true"></div>
    <img class="predictive-search-item__image lazyload"
      src="${collection.image.url}"
      data-src="${collection.image.url}"
      data-image
      alt="${collection.image.alt}"
    />
  `;
}

function renderItemImageSection(collection) {
  if (collection.image === null || collection.image === undefined) {
    return ' ';
  }

  return `
    <div class="predictive-search__column predictive-search__column--image" data-image-with-placeholder-wrapper>
      ${renderCollectionImage(collection)}
    </div>`;
}

export default (collection, index, resultsCount) => `
    <li id="search-result-${index}" class="predictive-search-item" role="option" data-search-result>
      <a class="predictive-search-item__link" href="${collection.url}" tabindex="-1">
        ${renderItemImageSection(collection)}
        <div class="predictive-search__column predictive-search__column--content ${
          getDetailsCount() ? '' : 'predictive-search__column--center'
        }">
          <span class="predictive-search-item__title">
            <span class="predictive-search-item__title-text">${collection.title}</span>
          </span>
          <span class="vh">, </span>
          <span class="vh">${getNumberOfResultsString(index + 1, resultsCount)}</span>
        </div>
      </a>
    </li>
  `;
